const URL_PDF = 'https://www.openbank.de/assets/static/de/pdf/';
const LEGAL_INFORMATION = URL_PDF + 'footer/Legal_information_DE.pdf';
const WEALTH_RATE = URL_PDF + 'Investments/Wealth_rate_780-4_DE.pdf';

const generatePdf = urlsPdfs => {
    return [LEGAL_INFORMATION, ...urlsPdfs, WEALTH_RATE];
};

export default {
    generatePdf,
};
